import { memo, type ReactNode } from 'react';

import type { AvatarShape } from '@didaskill/types/web';

import { Avatar } from '../avatar/Avatar';
import { type AVATAR_CONNECTION_STATUS, AVATAR_SIZES } from '../avatar/constants';
import * as styles from './AvatarBlock.styles';

export type AvatarBlockProps = {
  /** User to whom the avatar belongs. */
  user: AvatarShape;
  /** Title displayed under user's Avatar. */
  title: ReactNode;
  /** Status of user profile */
  status?: ReactNode;
  /** Avatar size. */
  size?: AVATAR_SIZES;
  /** Avatar connection status (ONLINE, OFFLINE). */
  connectionStatus?: AVATAR_CONNECTION_STATUS;
  /** Subtitle displayed under the title. */
  subtitle?: ReactNode;
};

export const AvatarBlockBase = ({
  user,
  title,
  size = AVATAR_SIZES.LARGE,
  status,
  connectionStatus,
  subtitle,
}: AvatarBlockProps) => (
  <div css={styles.container}>
    <Avatar user={user} size={size} connectionStatus={connectionStatus} />

    {status && <div>{status}</div>}

    <div css={styles.content}>
      {title}

      {subtitle && <div>{subtitle}</div>}
    </div>
  </div>
);

AvatarBlockBase.displayName = 'AvatarBlock';

export const AvatarBlock = memo(AvatarBlockBase);
